import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useDeviceType = () => {
    const theme = useTheme();

    const isSmallMobile = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.SMALL_MOBILE));
    const isMobile = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE));
    const isMobileOrTablet = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET));
    const isTablet = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET));
    const isTabletOrDesktop = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP));
    const isDesktop = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP));
    const isLargeDesktop = useMediaQuery(getThemeBreakpointByDeviceType(theme, EDeviceType.LARGE_DESKTOP));

    return {
        isSmallMobile,
        isMobile,
        isTablet,
        isDesktop,
        isLargeDesktop,
        isMobileOrTablet,
        isTabletOrDesktop,
    };
};
